import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import Pricing from 'pages/pricing/Pricing';

const DISMISS_STORAGE_KEY = 'pricing.modal.hidden_until';
const ONE_DAY_MS = 24 * 60 * 60 * 1000;

const PricingModal = ({ onClose }) => {
  const [dismissForDay, setDismissForDay] = useState(false);
  const location = useLocation();
  const initialPathRef = useRef(location.pathname);

  useEffect(() => {
    if (location.pathname !== initialPathRef.current) {
      onClose();
    }
  }, [location.pathname, onClose]);

  const handleClose = () => {
    if (dismissForDay) {
      try {
        localStorage.setItem(
          DISMISS_STORAGE_KEY,
          String(Date.now() + ONE_DAY_MS),
        );
      } catch {
        // ignore
      }
    }
    onClose();
  };

  return (
    <Overlay onClick={handleClose}>
      <Content onClick={(e) => e.stopPropagation()}>
        <CloseButton type="button" aria-label="닫기" onClick={handleClose}>
          ×
        </CloseButton>
        <PricingWrapper>
          <Pricing />
        </PricingWrapper>
        <Footer>
          <CheckboxLabel htmlFor="pricingModalDismiss">
            <input
              type="checkbox"
              id="pricingModalDismiss"
              checked={dismissForDay}
              onChange={(e) => setDismissForDay(e.target.checked)}
            />
            <span>하루동안 안보기</span>
          </CheckboxLabel>
          <CloseTextButton type="button" onClick={handleClose}>
            닫기
          </CloseTextButton>
        </Footer>
      </Content>
    </Overlay>
  );
};

export const shouldShowPricingModal = () => {
  try {
    const until = localStorage.getItem(DISMISS_STORAGE_KEY);
    if (!until) return true;
    return Date.now() >= Number(until);
  } catch {
    return true;
  }
};

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 1000;
  padding: 40px 20px;
  overflow-y: auto;
`;

const Content = styled.div`
  position: relative;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.16);
  max-width: 960px;
  width: 100%;
  padding-bottom: 12px;
`;

const PricingWrapper = styled.div`
  > div {
    padding: 32px 20px 16px;
  }

  h1 {
    font-size: 26px;
  }

  h1 + p {
    margin-bottom: 28px;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 20px;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: #f4f7fe;
  color: #4a5568;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  z-index: 1;

  &:hover {
    background: #e4e4e4;
  }
`;

const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 40px 8px;
  border-top: 1px solid #f0f0f0;
  margin: 0 20px;
`;

const CheckboxLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #4a5568;
  cursor: pointer;

  input {
    margin: 0;
  }
`;

const CloseTextButton = styled.button`
  padding: 10px 24px;
  border: 1.5px solid #e4e4e4;
  border-radius: 8px;
  background: #fff;
  color: #4a5568;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    border-color: #644ded;
    color: #644ded;
  }
`;

export default PricingModal;
